import { generate as e } from "./generate.js";
//#region src/suggestions.ts
async function t({ session: t, minSuggestions: n, maxSuggestions: r = 5, ...i } = {}) {
	let a = t?.__statefulMessages.get() ?? [];
	try {
		return (await e(`Suggest what the user should say to AI to ${a.length > 0 ? "continue the conversation" : "start a new conversation"}. Provide clear, highly relevant suggestions. Do not literally suggest tool calls. Instead, suggest what the user should say to achieve their goal, that may result in tool calls. 
        ${n ? `Provide at least ${n} suggestions.` : "If you have no suggestions, return an empty array."}. Provide at most ${r} suggestions.`, {
			type: "array",
			items: {
				type: "object",
				properties: {
					label: {
						type: "string",
						description: "The label of the suggestion. This is shown as a button and should be short. Each label should be unique. It should be no more 5 words."
					},
					message: {
						type: "string",
						description: "The message to send when the suggestion is clicked. This should be a clear, complete sentence and will be sent as an instruction to the AI."
					}
				},
				required: ["label", "message"],
				additionalProperties: !1
			}
		}, {
			...i,
			context: [...a.length > 0 ? [{
				description: "The last messages in the session",
				value: a.filter((e) => e.type !== "tool_call").slice(-2)
			}] : [], ...i?.context || []]
		})).slice(0, r);
	} catch (e) {
		throw e;
	}
}
//#endregion
export { t as generateCopilotSuggestions };
